import { createFileRoute, redirect } from "@tanstack/react-router"
import { ChangeProjectDivide } from "@/features/change-projects/components/ChangeProjectDivide"
import { canManageBulkUpdates } from "@/features/change-projects/core/access"

export const Route = createFileRoute("/(authenticated)/bulk-updates/$changeProjectId/divide")({
  beforeLoad: ({ context, params }) => {
    if (!canManageBulkUpdates(context.user)) {
      throw redirect({
        to: "/bulk-updates/$changeProjectId/review",
        params: { changeProjectId: params.changeProjectId },
        replace: true,
      })
    }
  },
  component: DivideStep,
})

function DivideStep() {
  const { changeProjectId } = Route.useParams()
  return <ChangeProjectDivide changeProjectId={changeProjectId} />
}
